import { Box } from '@mui/material';
import styled from 'styled-components';

interface IStyledUserInfoProps {
  disableShadow?: boolean;
}

export const StyledUserInfo = styled(Box)<IStyledUserInfoProps>`
  ${({ theme, disableShadow }) => `
    color: ${theme.uptimeColors.textColors.primary};
    
    .component-label {
      font-weight: 500;
      font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
      margin-bottom: ${theme.uptimeSpace[5]}px;
    }
    
    .info {
      width: 100%;
      display: flex;
      flex-direction: column;
      box-shadow: ${disableShadow ? 'none' : '4px 10px 30px 4px rgb(36 14 47 / 6%)'};
      border-radius: 12px;
      padding: ${disableShadow ? 0 : theme.uptimeSpace[6]}px ${theme.uptimeSpace[12]}px;
      
      .row {
        line-height: 2;
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        
        .label {
          font-weight: 600;
        }
      }
    }
  `}
`;